<template>
  <div v-if="texts" class="pt-12 md:pt-16">
    <h3 class="pb-6 text-subtitle font-medium">{{ t['w.module.product_description.product_text']() }}</h3>
    <ul class="list">
      <li v-for="(text, index) of texts" v-show="isAnchorText(text) === false" :key="`product-text-${index}`" v-html="text" />
      <li v-if="brand?.url">
        <I18n :message="t['w.module.product_description.brand']">
          <template #brand>
            <NuxtLink class="text-text-strong underline" :to="brand.url" target="_blank">{{ brand.name }}</NuxtLink>
          </template>
        </I18n>
      </li>
      <li v-else-if="brand">
        <span>{{ t['w.module.product_description.no_brand_link']() }}: {{ brand.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import * as t from '~/messages'
import I18n from '~/components/i18n/I18n.vue'

interface Brand {
  url: string | null
  name: string
}

withDefaults(
  defineProps<{
    texts?: string[] | null
    title?: string | null
    brand?: Brand | null
  }>(),
  {
    texts: null,
    title: null,
    brand: null,
  }
)

const removedTextLinks = ref<string[]>([])

const isAnchorText = (text: string) => {
  const anchorRegex = /<a\b[^>]*>(.*?)<\/a>/
  const anchorTextMatch = anchorRegex.exec(text)

  if (anchorTextMatch !== null) {
    const modifiedText = anchorTextMatch[0].replace(/style="[^"]*"/g, '')
    removedTextLinks.value.push(modifiedText)

    return true
  }

  return false
}

const emit = defineEmits<{
  'removed-links': [removedLinks: string[]]
}>()

const emitRemovedTags = () => {
  emit('removed-links', removedTextLinks.value)
}

onMounted(() => {
  emitRemovedTags()
})

onBeforeUnmount(() => {
  emitRemovedTags()
})
</script>
